export const AUTH_LOGIN_LOADING = "auth/login/loading";
export const AUTH_LOGIN_ERROR = "auth/login/error";
export const AUTH_LOGIN_SUCCESS = "auth/login/success";
export const AUTH_LOGOUT = "auth/logout";
export const AUTH_SIGNUP_LOADING = "auth/signup/loading";
export const AUTH_SIGNUP_ERROR = "auth/signup/error";
export const AUTH_SIGNUP_SUCCESS = "auth/signup/success";

export const AUTH_CHECK_LOADING = "auth/check/loading";
export const AUTH_CHECK_ERROR = "auth/check/error";
export const AUTH_CHECK_SUCCESS = "auth/check/success";